<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      
    }
  },
  created() {},
  methods: {
    
  }
}
</script>
<style>
@import "@/assets/iconfont/iconfont.css";
@import "@/assets/common.scss";
</style>

